var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-btn',_vm._g(_vm._b({staticClass:"ma-3",attrs:{"fab":"","small":""}},'v-btn',_vm.$attrs,false),_vm.$listeners),[_c('v-icon',[_vm._v(_vm._s(_vm.icon))])],1)}
var staticRenderFns = []

export { render, staticRenderFns }